import axios, {AxiosError, AxiosResponse} from 'axios';
import {BASE_URL} from '../constants';
import API_ENDPOINTS from './endpoints';
import {hasUnsyncedChanges, synchronize} from '@nozbe/watermelondb/sync';
import Cookies from 'js-cookie';
import {database} from '../pos-core/database';
import {getTemplateImagesToUpload} from '../pos-core/database/helpers';

export const Axios = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

export const handleApi = async axiosPromise => {
    try {
        return (await axiosPromise).data;
    } catch (err) {
        console.log(err);

        if (err instanceof AxiosError) {
            throw err;
        }

        if (err instanceof Error) {
            throw err;
        }

        throw err;
    }
};
export const handleCatalogsApi = async axiosPromise => {
    try {
        return await axiosPromise;
    } catch (error) {
        console.log('err', error);
        return error;
    }
};
export const handleLoginApi = async axiosPromise => {
    try {
        return await axiosPromise;
    } catch (err) {
        console.log(err);
        return err;
    }
};
export const Sync = async (username, clearPulledAt = false) => {
    console.log('Initiate Sync');

    let time = clearPulledAt ? null : localStorage.getItem(username);

    try {
        await handleImageBackup();
    } catch (err) {
        console.log('err in handleImageBackup', err);
    }

    await synchronize({
        database,
        pullChanges: async ({lastPulledAt, schemaVersion, migration}) => {
            lastPulledAt = time ? Number(time) : undefined;

            let syncStatus = await hasUnsyncedChanges({database});

            let paramsForApi = {
                lastPulledAt,
                schemaVersion,
                migration,
                hasUnsyncedChanges: syncStatus,
            };

            const response = await Axios.get(API_ENDPOINTS.SYNC, {
                params: paramsForApi,
                headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
            });

            if (!(response.status == 200)) {
                throw new Error(await response.statusText);
            }

            console.log('response', response);
            const {changes, sync_timestamp} = response.data;
            if (sync_timestamp) {
                localStorage.setItem(username, sync_timestamp.toString());
            }
            let timestamp = sync_timestamp;

            return {changes, timestamp};
        },
        pushChanges: async ({changes}) => {
            const paramsForApi = {
                params: {
                    changes,
                },
            };

            const response = await Axios.post(API_ENDPOINTS.SYNC, paramsForApi, {
                headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
            });

            if (!(response.status == 200)) {
                throw new Error(await response.statusText);
            }
        },
    });
};

const handleImageBackup = () => {
    return new Promise(async (resolve, reject) => {
        try {
            let templateImages = await getTemplateImagesToUpload();

            let imagesToUpload = [...templateImages];

            if (imagesToUpload.length) {
                let promises = imagesToUpload.map(val => {
                    return new Promise(async (resolve, reject) => {
                        try {
                            let paramsToUpload = {
                                data: val.image,
                                data_id: val.id,
                                data_type: val.table,
                            };

                            let {url} = await postUploadImage(paramsToUpload);

                            console.log('url', url);
                            await val.updateImage(url);

                            resolve();
                        } catch (err) {
                            console.log('err in updateImage', err);
                            reject(err);
                        }
                    });
                });

                Promise.all(promises)
                    .then(() => {
                        console.log('All images backed up');
                    })
                    .catch(err => {
                        console.log('err in uploading images', err);
                        reject(err);
                    });
            } else {
                console.log('No images to backup');
            }

            resolve();
        } catch (err) {
            console.log('Err in handleImageBackup', err);
            reject(err);
        }
    });
};

export const postUserLogin = payload => handleLoginApi(Axios.post(API_ENDPOINTS.LOGIN, payload));

export const getCatalogsData = payload => handleCatalogsApi(Axios.get(API_ENDPOINTS.GET_CATALOGS, {params: payload}));

export const postAccountRegister = payload => handleApi(Axios.post(API_ENDPOINTS.REGISTER, payload));

export const getCheckUsername = payload => handleApi(Axios.get(API_ENDPOINTS.CHECK_USERNAME, {params: payload}));

export const getCheckPhoneNumber = payload => handleApi(Axios.get(API_ENDPOINTS.CHECK_PHONE_NUMBER, {params: payload}));

export const updatePassword = payload =>
    handleApi(
        Axios.post(API_ENDPOINTS.UPDATE_PASSWORD, payload, {
            headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
        }),
    );

export const postUploadImage = payload =>
    handleApi(
        Axios.post(API_ENDPOINTS.UPLOAD_IMAGE, payload, {
            headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
        }),
    );

// Kitched Display API'S

export const createDevice = payload =>
    handleApi(
        Axios.post(`${API_ENDPOINTS.CREATE_DEVICE}device/`, payload, {
            headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
        }),
    );

export const getAccountDevices = () =>
    handleApi(
        Axios.get(`${API_ENDPOINTS.CREATE_DEVICE}device/`, {
            headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
        }),
    );

export const updatePin = (payload, deviceId) =>
    handleApi(
        Axios.post(`${API_ENDPOINTS.UPDATE_PIN}${deviceId}/`, payload, {
            headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
        }),
    );

export const sendEmail = payload =>
    handleApi(
        Axios.post(API_ENDPOINTS.SEND_EMAIL, payload, {
            headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
        }),
    );

export const sendUserCredentials = payload =>
    handleApi(
        Axios.post(API_ENDPOINTS.SEND_USER_CRED, payload, {
            headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
        }),
    );

export const loginDevice = payload => handleApi(Axios.post(API_ENDPOINTS.LOGIN_DEVICE, payload));

export const validateDevicePin = payload => handleApi(Axios.post(API_ENDPOINTS.VALIDATE_PIN, payload));

export const updateOdooConfig = (payload, deviceId) =>
    handleApi(
        Axios.post(`${API_ENDPOINTS.UPDATE_ODOO_CONFIG}${deviceId}/`, payload, {
            headers: {Authorization: `Bearer ${Cookies.get('access_token')}`},
        }),
    );

export const getKitchenOrders = deviceId => handleApi(Axios.get(`${API_ENDPOINTS.GET_KDS_ORDER}${deviceId}/`));

export const getKitchenOrdersHistory = (deviceId, payload) => handleApi(Axios.get(`${API_ENDPOINTS.GET_KDS_ORDER}${deviceId}/`, {params: payload}));

export const updateKitchenOrder = payload => handleApi(Axios.post(`${API_ENDPOINTS.UPDATE_KDS_ORDER}`, payload));

export const kitchenNotifications = payload => handleApi(Axios.post(`${API_ENDPOINTS.KITCHEN_NOTIFICATIONS}`, payload));

export const updateDeviceConfiguration = (payload, deviceId) => handleApi(Axios.put(`${API_ENDPOINTS.UPDATE_DEVICE_CONFIG}${deviceId}/`, payload));

export const getAllCountry = payload => handleApi(Axios.get(API_ENDPOINTS.GET_COUNTRY));
